// Aan/Uit-badge voor tweestapsverificatie. Gedeeld door Mijn profiel
// (TwoFactorSettings) en het herstelscherm voor superadmins (MfaRecovery),
// zodat beide dezelfde woorden en kleuren tonen.
// AI-CONTEXT: See docs/features/mfa-totp.md

/**
 * @param {object} props
 * @param {boolean} props.on - Of er een tweede stap gekoppeld is
 */
const TwoFactorStatusBadge = ({ on }) => (
    <span
        role='status'
        aria-label={on ? 'Tweestapsverificatie staat aan' : 'Tweestapsverificatie staat uit'}
        className={`two-factor-status two-factor-status--${on ? 'on' : 'off'}`}
    >
        {on ? 'Aan' : 'Uit'}
    </span>
)

export default TwoFactorStatusBadge
